import { BaseEntity } from '../../../../models';
import { Usuario } from '../../../usuario/usuario';

export class RepresentanteAtendente implements BaseEntity {
    readonly id: number;
    idRepresentante: number;
    idUsuarioAtendente: number;
    usuarioAtendente: Usuario;
}
